module.exports = __webpack_public_path__ + "static/media/c2bannerModul2_small.2b21fec7.jpg";